import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import InlineMessage from '@atlaskit/inline-message';
import { ReadOnlyReason } from '../../jira-common/models';
import { useFormSaveQuestionError } from '../controllers/save-errors';
import { ValidationErrorMsg } from '../utils/validation/validationErrorMessages.intl';
import { LinkedFieldIcon } from './linked-field-icon';
import { messages } from './messages';
import { defaultQuestionTypeRendererMap } from './questions';
import { QuestionErrorMsg } from './questions/common/QuestionErrorMsg';
import { QuestionHelperMsg } from './questions/common/QuestionHelperMsg';
import { LabelWrapper } from './questions/common/questionWrappers';
import { UnknownQuestionType } from './questions/unknown-question-type';
import { DisplayMode } from './RenderForm';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var LinkedFieldIconWrapper = styled.span({
  marginLeft: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var QuestionLabelWrapper = styled.span({
  display: 'flex'
});
export var RenderQuestion = observer(function (_ref) {
  var _questionTypeRenderer;
  var QuestionRenderer = _ref.QuestionRenderer,
    questionTypeRendererMap = _ref.questionTypeRendererMap,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode,
    formStore = _ref.formStore,
    blockFormSubmission = _ref.blockFormSubmission,
    linkedFieldNames = _ref.linkedFieldNames;
  var intl = useIntl();
  var formQuestion = questionStore.formQuestion,
    questionId = questionStore.id,
    issueFieldData = questionStore.issueFieldData,
    revisionToken = questionStore.revisionToken,
    validationErrors = questionStore.validationErrors;
  var fieldId = "pf-".concat(formStore.formId, "-").concat(formQuestion.type, "-").concat(questionId);
  var formSaveQuestionError = useFormSaveQuestionError(questionId);
  var questionProps = {
    questionStore: questionStore,
    formStore: formStore,
    displayMode: displayMode,
    id: fieldId,
    revisionToken: revisionToken,
    blockFormSubmission: blockFormSubmission
  };
  var QuestionTypeRenderer = (_questionTypeRenderer = questionTypeRendererMap === null || questionTypeRendererMap === void 0 ? void 0 : questionTypeRendererMap[formQuestion.type]) !== null && _questionTypeRenderer !== void 0 ? _questionTypeRenderer : defaultQuestionTypeRendererMap[formQuestion.type];
  var questionComponent = QuestionTypeRenderer ? /*#__PURE__*/React.createElement(QuestionTypeRenderer, questionProps) : /*#__PURE__*/React.createElement(UnknownQuestionType, {
    questionType: formQuestion.type
  });
  var allQuestionErrors = [];
  if (displayMode === DisplayMode.Edit) {
    allQuestionErrors = [].concat(_toConsumableArray(validationErrors ? validationErrors : []), _toConsumableArray(formSaveQuestionError ? [{
      key: ValidationErrorMsg.FormSave,
      message: formSaveQuestionError
    }] : []));
  }
  var warningMessage;
  switch (issueFieldData === null || issueFieldData === void 0 ? void 0 : issueFieldData.readOnlyReason) {
    case ReadOnlyReason.Anonymous:
      warningMessage = messages.readOnlyReasonAnonymousMessage;
      break;
    case ReadOnlyReason.Unlicensed:
      warningMessage = messages.readOnlyReasonUnlicensedMessage;
      break;
    default:
  }
  return QuestionRenderer !== undefined ? /*#__PURE__*/React.createElement(QuestionRenderer, {
    questionId: questionId.toString(),
    fieldId: fieldId,
    formQuestion: formQuestion,
    questionComponent: questionComponent
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelWrapper, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: fieldId,
    id: "label-".concat(fieldId)
  }, /*#__PURE__*/React.createElement(QuestionLabelWrapper, null, formQuestion.label, formQuestion.validation.rq && /*#__PURE__*/React.createElement(RequiredAsterisk, null), formQuestion.jiraField && linkedFieldNames && /*#__PURE__*/React.createElement(LinkedFieldIconWrapper, null, /*#__PURE__*/React.createElement(LinkedFieldIcon, {
    fieldName: linkedFieldNames === null || linkedFieldNames === void 0 ? void 0 : linkedFieldNames.get(formQuestion.jiraField)
  })))), warningMessage && /*#__PURE__*/React.createElement(InlineMessage, {
    appearance: "connectivity",
    iconLabel: intl.formatMessage(warningMessage)
  }, /*#__PURE__*/React.createElement(FormattedMessage, warningMessage))), /*#__PURE__*/React.createElement(QuestionHelperMsg, {
    description: formQuestion.description
  }), questionComponent, /*#__PURE__*/React.createElement(QuestionErrorMsg, {
    validationErrors: allQuestionErrors.length === 0 ? undefined : allQuestionErrors
  }));
});